import React from 'react';
import cn from 'classnames';

import TabsWithLinks from './components/TabsWithLinks';
import SubmenuLink from './components/SubmenuLink';
import Link from 'components/UI/Link';
import { handleLinkClick } from '../../utils';

import * as styles from './SubMenu.module.scss';

function SubMenu({
  items = [],
  parentLink,
  currentLink,
  active,
  withTransition,
  theme = 'links',
  className,
  deviceType,
}) {
  const renderLinks = links => {
    if (links.some(item => Boolean(item.linkList))) {
      return <TabsWithLinks links={links} subMenuActive={active} />;
    }

    return (
      <>
        <div className={styles.linksWrap}>
          {links.map((link, i) => (
            <SubmenuLink
              {...link}
              key={`link-${i}`}
              className={styles.link}
              mod={theme}
              currentLink={currentLink}
              deviceType={deviceType}
              tabIndex={active ? 0 : -1}
            />
          ))}
        </div>
        {parentLink && (
          <Link
            href={parentLink.url}
            className={styles.parentLink}
            onClick={() => handleLinkClick(parentLink.url)}
            tabIndex={active ? 0 : -1}
          >
            {parentLink.title}
          </Link>
        )}
      </>
    );
  };

  return (
    <div
      className={cn(
        styles.subMenu,
        active && styles.visible,
        withTransition && styles.withTransition,
        styles[theme],
        className,
      )}
      aria-hidden={!active}
    >
      <div className={styles.layout}>{renderLinks(items)}</div>
    </div>
  );
}

export default React.memo(SubMenu);
